<template>
  <div>
    <!-- <vueVimeoPlayer
      class="vimeo-player mt-5"
      :video-id="applicant.video"
    ></vueVimeoPlayer> -->

    <Video
      :videoId="applicant.video"
      styled="true"
      muted="false"
      class="mt-5"
    />

    <v-form
      ref="form"
      v-model="valid"
      @submit.prevent="handleSubmit"
      class="mt-5"
    >
      <span class="display-1 text--primary">
        {{ applicant.user.firstName }}
        {{ applicant.user.surname }}
      </span>

      <div class="d-flex justify-space-between align-center mb-5">
        <div>
          <div v-if="applicant.resume">
            <v-icon>mdi-file-pdf-outline</v-icon>

            <a
              :href="applicant.resume.url"
              target="_blank"
              rel="noopener noreferrer"
              >View Resume</a
            >
          </div>
        </div>
        <div>
          <v-input :value="rating" :rules="[rules.required]">
            <v-rating
              v-model="rating"
              background-color="yellow darken-3"
              color="orange"
              half-increments
              hover
            ></v-rating>
          </v-input>
        </div>
      </div>
      <v-textarea
        v-model="feedback"
        outlined
        label="Candidate Feedback"
        counter
        :rules="[this.rules.required]"
        no-resize
      ></v-textarea>

      <div class="text-center">
        <v-btn type="submit" :disabled="!valid" color="success" x-large
          >View Next Candidate</v-btn
        >
      </div>
    </v-form>
  </div>
</template>

<script>
import Video from '@/components/Video';

// import JOB_POST from '@/graphql/JobPost.gql';
import UPDATE_APPLICANT from '@/graphql/UpdateApplicant.gql';
import UPDATE_JOBPOST from '@/graphql/UpdateJobPost.gql';

export default {
  components: { Video },

  data() {
    return {
      rating: null,
      feedback: '',
      valid: false,
      rules: {
        required: (value) => !!value || 'Required.',
        min: (v) => v.length >= 5 || 'Min 5 characters',
      },
    };
  },
  methods: {
    handleSubmit() {
      this.$apollo
        .mutate({
          // Query
          mutation: UPDATE_APPLICANT,
          // Parameters
          variables: {
            id: this.applicant.id,
            rating: this.rating,
            feedback: this.feedback,
          },
        })
        .then((data) => {
          // Result
          console.log(data);
          //set to reviewed
          if (!this.queuedApplicantsLength) {
            console.log('MUTATE');
            this.$apollo
              .mutate({
                // Query
                mutation: UPDATE_JOBPOST,
                // Parameters
                variables: {
                  id: this.jobPost.id,
                  status: 'reviewed',
                },
              })
              .then((data) => {
                console.log(data);
                this.$router.go(this.$router.currentRoute);
              })
              .catch((error) => {
                // Error
                console.error(error);
              });
          } else {
            this.$router.go(this.$router.currentRoute);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },

  props: ['applicant', 'queuedApplicantsLength', 'jobPost'],
};
</script>

<style></style>
